import Vue from 'vue';
import axios from 'axios';
import CommonService from '@/services/CommonService';
import { PURGE_AUTH, SET_MESSAGE_MODAL } from '@/store/mutation-types';

export const status = {
  HTTP_BAD_REQUEST: 400,
  HTTP_UNAUTHORIZED: 401,
  HTTP_FORBIDDEN: 403,
  HTTP_NOT_FOUND: 404,
  HTTP_INTERNAL_SERVER_ERROR: 500,
  HTTP_CONFLICT: 409,
};

export default (inline = false, contentType = 'application/json', responseType = 'json') => {
  const { router, store } = Vue.prototype;
  const { user, token } = store.state.auth;
  const apiUrl = process.env.VUE_APP_API_URL
    ? process.env.VUE_APP_API_URL
    : ('https://' + location.hostname + '/api');
  const axiosInstance = axios.create({
    baseURL: apiUrl,
    withCredentials: false,
    responseType,
    headers: {
      'Accept': 'application/json',
      'Content-Type': contentType,
      'X-Pos-Auth': CommonService.generateJWT(user.username, token),
    },
  });

  axiosInstance.interceptors.request.use(function (config) {
    return config;
  });

  axiosInstance.interceptors.response.use(response => {
    return response;
  }, (error) => {
    if (error.message == 'Network Error') {
      let data = {
        error: "Network Error",
        code: 500
      };
      store.commit(SET_MESSAGE_MODAL, data);
      return false;
    }
    if ((error.response.status === status.HTTP_UNAUTHORIZED
      //|| error.response.status === status.HTTP_FORBIDDEN)
    )
      && error.config.url !== (`${process.env.VUE_APP_API_URL}/auth`)) {
      store.commit(SET_MESSAGE_MODAL, error.response.data);
      store.commit(PURGE_AUTH);
      return router.push({ name: 'login' });
    }
    if (inline) {
      return Promise.reject(error.response.data);
    }
    if (error.response.status === status.HTTP_BAD_REQUEST
      || error.response.status === status.HTTP_FORBIDDEN
      || error.response.status === status.HTTP_NOT_FOUND
      || error.response.status === status.HTTP_CONFLICT
      || error.response.status === status.HTTP_INTERNAL_SERVER_ERROR) {
          store.commit(SET_MESSAGE_MODAL, error.response.data);
    }

    return false;
  });

  return axiosInstance;
};
